import React, { useRef, useCallback } from 'react';
import { OrbitControls } from '@react-three/drei';
import { trackSceneInteraction } from '../analytics';

const DefaultScene = () => {
  const hasTracked = useRef(false);

  const handleStart = useCallback(() => {
    if (!hasTracked.current) {
      hasTracked.current = true;
      trackSceneInteraction('DefaultScene', 'interact');
    }
  }, []);

  return (
    <>
      <ambientLight intensity={0.4} />
      <directionalLight position={[4, 6, 4]} intensity={0.8} />
      <mesh rotation={[0.4, 0.6, 0]}>
        <boxGeometry args={[1.4, 1.4, 1.4]} />
        <meshStandardMaterial color="#e5c9a6" roughness={0.35} metalness={0.1} />
      </mesh>
      <OrbitControls enableZoom={false} onStart={handleStart} />
    </>
  );
};

export default DefaultScene;

